import React, {  useEffect, useState,useCallback } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next"; 
import { ENDPOINT,DEFAULT_STORE,DEFAULTSUBSTORE } from "constants/variables";
import Box from '@mui/material/Box'; 
import Container from '@mui/material/Container'; 
import TextField from '@mui/material/TextField'; 
import SwipeableDrawer from '@mui/material/SwipeableDrawer'; 
import { warningErrorAction } from "actions/ErrorActions";
import "css/generalSettings.css";
import { helpHttp } from "service/HelpHttp";
import PropTypes from 'prop-types'; 

const initialArticleNumSerial = [
  {
    "id" : 0,
    "indexrowsnumseriales":0,
    "store_id" : 0,
    "store_name" : "",
    "substore_id" : 0,
    "substore_name" : "",
    "typeofsize_id" : 0,
    "typeofsize_namees" : "",
    "typeofsize_nameen" : "",
    "typeofsize_symbolsizes": "",
    "color_id" : 0,
    "color_namees" : "",
    "color_nameen" : "",
    "color_codehex": "",
    "serialnumber" : ""
  }
];

const ArticleCreateOrEditNumSerial = ({
  openEditRowStoresNumSerial,
  setOpenEditRowStoresNumSerial,
  openEditNewStoresNumSerial,
  setOpenEditNewStoresNumSerial,
  formArticle,
  setFormArticle,
  editRowStoreNumSerial,
  setEditRowStoreNumSerial, 
  subStoresToSelect,
  typesOfSizeToSelect,
  colorToSelect
}) => {
  const {t,i18n} = useTranslation(['listDataArticles']); 
  const token = useSelector((state) => state.loginUser.token); 
  const [newNumSerial,setNewNumSerial]= useState(initialArticleNumSerial);
  const [errorsNumSerial, setErrorsNumSerial] = useState({});
  const [foundNumSerial, setFoundNumSerial ]= useState(false);
  const dispatch = useDispatch();

  const keyPress = useCallback(
    e => {
      if (e.key === 'Escape' && openEditRowStoresNumSerial) {
        setNewNumSerial(newNumSerial => ({
          ...newNumSerial,
          id:0,
          indexrowsnumseriales:0,
          store_id : Number(DEFAULT_STORE),
          store_name:"",
          substore_id : Number(DEFAULTSUBSTORE),
          substore_name:"",
          typeofsize_id:0,
          typeofsize_namees:"",
          typeofsize_nameen:"",
          typeofsize_symbolsizes:"",
          color_id:0,
          color_namees:"",
          color_nameen:"",
          color_codehex:"",
          serialnumber:""
        }));
        setErrorsNumSerial({});
        setEditRowStoreNumSerial(initialArticleNumSerial);
        setOpenEditRowStoresNumSerial(false);
        setOpenEditNewStoresNumSerial(false); 
        setFoundNumSerial(false);
      }
    },[
      setNewNumSerial,
      setErrorsNumSerial, 
      setEditRowStoreNumSerial,
      setOpenEditRowStoresNumSerial,
      openEditRowStoresNumSerial,
      setOpenEditNewStoresNumSerial,
      setFoundNumSerial
      ]
  );

  const handleCloseNewNumSerial = () => {
    setNewNumSerial(newNumSerial => ({
      ...newNumSerial,
      id:0,
      indexrowsnumseriales:0,
      store_id : Number(DEFAULT_STORE),
      store_name:"",
      substore_id : Number(DEFAULTSUBSTORE),
      substore_name:"",
      typeofsize_id:0,
      typeofsize_namees:"",
      typeofsize_nameen:"",
      typeofsize_symbolsizes:"",
      color_id:0,
      color_namees:"",
      color_nameen:"",
      color_codehex:"",
      serialnumber:""
    }));
    setErrorsNumSerial({});
    setEditRowStoreNumSerial(initialArticleNumSerial);
    setOpenEditRowStoresNumSerial(false);
    setOpenEditNewStoresNumSerial(false); 
    setFoundNumSerial(false);
  };
   
  const handleBlurSelectSubStore = (e) => {
    handleChangeSelectSubStore(e);
    setErrorsNumSerial(validateFormNumSerial());
  };

  const handleChangeSelectSubStore = (event) => {
    setNewNumSerial(newNumSerial => ({
      ...newNumSerial,
      substore_id:event.target.value
    }));
  };

  const handleChangeSelectTypesOfSize = (event) => {
    setNewNumSerial(newNumSerial => ({
      ...newNumSerial,
      typeofsize_id:event.target.value
    }));
  };

  const handleBlurSelectTypesOfSize= (e) => {
    handleChangeSelectTypesOfSize(e);
    setErrorsNumSerial(validateFormNumSerial());
  };

  const handleChangeSelectColor = (event) => {
    if (event.target.value!==""){
      setNewNumSerial(newNumSerial => ({
        ...newNumSerial,
        color_id:event.target.value,
        color_codehex:colorToSelect.find((key=>key.id===Number(event.target.value))).codehex
      }));
    }
  };

  const handleBlurSelectColor= (e) => {
    handleChangeSelectColor(e);
    setErrorsNumSerial(validateFormNumSerial());
  };

  const handleChangeNewNumSerial = (e) => {
    const { name, value } = e.target;
    setNewNumSerial(newNumSerial => ({
      ...newNumSerial,
      [name]: value
    }));   
  };
  const handleBlurNewNumSerial = (e) => {
    handleChangeNewNumSerial(e);
    setErrorsNumSerial(validateFormNumSerial());
  };

  const toggleDrawernewNumSerial  = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      handleCloseNewNumSerial();
    }
  }

  const validateFormNumSerial = () => {
    let errorsNumSerial = {};
    
    if (newNumSerial.substore_id===undefined || newNumSerial.substore_id===null || newNumSerial.substore_id==="" || newNumSerial.substore_id==="0" || newNumSerial.substore_id===0){
      errorsNumSerial.substore_id = 'Text_SubStoreRequired';
    } 
    if (newNumSerial.serialnumber===""  || newNumSerial.serialnumber===null){
      errorsNumSerial.serialnumber = 'Text_NumSerialRequired';
    } else{
      if (foundNumSerial && newNumSerial.serialnumber!==""){
        errorsNumSerial.serialnumber='Text_NumSerial_Exist';
      }else{
        if (!openEditNewStoresNumSerial){
          if (formArticle.articlestorenumseriales.find(item => {return (item.serialnumber.trim()=== newNumSerial.serialnumber.trim()) })){
            errorsNumSerial.serialnumber = 'Text_NumSerial_Exist';
          }
        }else{
          if (formArticle.articlestorenumseriales.find((item) => {return(item.indexrowsnumseriales!==newNumSerial.indexrowsnumseriales && item.serialnumber.trim()=== newNumSerial.serialnumber.trim()) })){
            errorsNumSerial.serialnumber = 'Text_NumSerial_Exist';
          }
        }
      }
    }
    if (formArticle.applytypesofsize
      && (newNumSerial.typeofsize_id===undefined 
      || newNumSerial.typeofsize_id===null 
      || newNumSerial.typeofsize_id==="" 
      || newNumSerial.typeofsize_id==="0" 
      || newNumSerial.typeofsize_id===0)){
        errorsNumSerial.typeofsize_id = 'Text_TypesOfSizeRequired';
    }
    if (formArticle.applycolor     
      && (newNumSerial.color_id===undefined 
      || newNumSerial.color_id===null 
      || newNumSerial.color_id==="" 
      || newNumSerial.color_id==="0" 
      || newNumSerial.color_id===0)){
        errorsNumSerial.color_id = 'Text_ColorRequired';
    }
    return errorsNumSerial;
  };

  const handleSubmitNewNumSerial = () => {  
    setErrorsNumSerial(validateFormNumSerial());
    let errorsCheckNumSerial=validateFormNumSerial();
    if ((Object.keys(errorsCheckNumSerial).length === 0) 
          && newNumSerial.substore_id!==undefined 
          && newNumSerial.substore_id!==null 
          && newNumSerial.substore_id!=="" 
          && newNumSerial.substore_id!=="0" 
          && newNumSerial.substore_id!==0
          && newNumSerial.serialnumber!==''  
          && newNumSerial.serialnumber!==null ) {
      
      let substoreFound = subStoresToSelect.find( item => item.id === Number(newNumSerial.substore_id));
      let typesOfSizeFound = typesOfSizeToSelect.find( item => item.id === Number(newNumSerial.typeofsize_id));
      let colorFound = colorToSelect.find( item => item.id === Number(newNumSerial.color_id));
      if (substoreFound!==undefined ) {
          let typesOfSizeToAdd={
            "id":newNumSerial.id!==null?newNumSerial.id:"",
            "indexrowsnumseriales": openEditNewStoresNumSerial?newNumSerial.indexrowsnumseriales:formArticle.articlestorenumseriales.length>0?formArticle.articlestorenumseriales[formArticle.articlestorenumseriales.length-1].indexrowsnumseriales+1:1,
            "store_id" : substoreFound.store_id,
            "store_name" :substoreFound.tradename,
            "substore_id" : substoreFound.id,
            "substore_name" : substoreFound.name,
            "typeofsize_id":formArticle.applytypesofsize?typesOfSizeFound.id:0,
            "typeofsize_namees":formArticle.applytypesofsize?typesOfSizeFound.namees:"",
            "typeofsize_nameen":formArticle.applytypesofsize?typesOfSizeFound.nameen:"",
            "typeofsize_symbolsizes":formArticle.applytypesofsize?typesOfSizeFound.symbolsizes:"",
            "color_id":formArticle.applycolor?colorFound.id:0,
            "color_namees":formArticle.applycolor?colorFound.namees:"",
            "color_nameen":formArticle.applycolor?colorFound.nameen:"",
            "color_codehex":formArticle.applycolor?colorFound.codehex:"",
            "serialnumber" : newNumSerial.serialnumber
        }
        if (!openEditNewStoresNumSerial){
          formArticle.articlestorenumseriales.push(typesOfSizeToAdd);
        }else{
          let idx=formArticle.articlestorenumseriales.findIndex(((item) => item.indexrowsnumseriales === newNumSerial.indexrowsnumseriales));
          formArticle.articlestorenumseriales[idx]=typesOfSizeToAdd
        }
        setFormArticle(formArticle => ({
          ...formArticle,
        }))
      }
      handleCloseNewNumSerial();
    }else{
      if (errorsCheckNumSerial.substore_id){
        dispatch(warningErrorAction(t(errorsCheckNumSerial.substore_id)));
      }else{
        if (errorsCheckNumSerial.typeofsize_id){
          dispatch(warningErrorAction(t(errorsCheckNumSerial.typeofsize_id)));
        }else{
          if (errorsCheckNumSerial.color_id){
            dispatch(warningErrorAction(t(errorsCheckNumSerial.color_id)));
          }else{
            if (errorsCheckNumSerial.serialnumber){
              dispatch(warningErrorAction(t(errorsCheckNumSerial.serialnumber)));
            }else{
              dispatch(warningErrorAction(t('Text_Error_Save_Data')));
            }
          }  
        }
      }      
    }  
  };
  
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);
 
  useEffect(() => {
    if (openEditNewStoresNumSerial ){
      setNewNumSerial(newNumSerial => ({
        ...newNumSerial,
        id:editRowStoreNumSerial.id!==null?editRowStoreNumSerial.id:"",
        indexrowsnumseriales:editRowStoreNumSerial.indexrowsnumseriales!==null?editRowStoreNumSerial.indexrowsnumseriales:1,
        store_id:editRowStoreNumSerial.store_id!==null?editRowStoreNumSerial.store_id:Number(DEFAULT_STORE),
        store_name:editRowStoreNumSerial.store_name!==null?editRowStoreNumSerial.store_name:"",
        substore_id:editRowStoreNumSerial.substore_id!==null?editRowStoreNumSerial.substore_id:Number(DEFAULTSUBSTORE),
        substore_name:editRowStoreNumSerial.substore_name!==null?editRowStoreNumSerial.substore_name:"",
        typeofsize_id:editRowStoreNumSerial.typeofsize_id!==null?editRowStoreNumSerial.typeofsize_id:0,
        typeofsize_namees:editRowStoreNumSerial.typeofsize_namees!==null?editRowStoreNumSerial.typeofsize_namees:"",
        typeofsize_nameen:editRowStoreNumSerial.typeofsize_nameen!==null?editRowStoreNumSerial.typeofsize_nameen:"",
        typeofsize_symbolsizes:editRowStoreNumSerial.typeofsize_symbolsizes!==null?editRowStoreNumSerial.typeofsize_symbolsizes:"",
        color_id:editRowStoreNumSerial.color_id!==null?editRowStoreNumSerial.color_id:0,
        color_namees:editRowStoreNumSerial.color_namees!==null?editRowStoreNumSerial.color_namees:"",
        color_nameen:editRowStoreNumSerial.color_nameen!==null?editRowStoreNumSerial.color_nameen:"",
        color_codehex:editRowStoreNumSerial.color_codehex!==null?editRowStoreNumSerial.color_codehex:"",
        serialnumber:editRowStoreNumSerial.serialnumber!==null?editRowStoreNumSerial.serialnumber:""
      }));
    }else{
      setNewNumSerial(newNumSerial => ({
        ...newNumSerial,
        id:0,
        indexrowsnumseriales:0,
        store_id : Number(DEFAULT_STORE),
        store_name:"",
        substore_id : Number(DEFAULTSUBSTORE),
        substore_name:"",
        typeofsize_id:0,
        typeofsize_namees:"",
        typeofsize_nameen:"",
        typeofsize_symbolsizes:"",
        color_id:0,
        color_namees:"",
        color_nameen:"",
        color_codehex:"",
        serialnumber:""
      }));
    }
  },[t,token,dispatch,i18n,editRowStoreNumSerial,openEditNewStoresNumSerial]);
    
  useEffect(() => {
    let isMounted = true;
    const fetchExistNumSerial = async () => {
      const getData = await helpHttp().get2(ENDPOINT,`articles/getarticlestorebynumserial/`, token,newNumSerial.serialnumber.replace(/[.\-/\\|]/g, "").trim());
      if (getData.err) {
        dispatch(warningErrorAction(t('Text_InvalidCredentials')));
      } else if (isMounted) {
        setFoundNumSerial(getData!==newNumSerial.id && getData>0)  
      }
    };  
    if (openEditRowStoresNumSerial){
      if (newNumSerial.serialnumber && newNumSerial.serialnumber.replace(/[.\-/\\|]/g, "").trim()!=="") { 
        fetchExistNumSerial();
      }  
    }  
  }, [t,token,dispatch,i18n,newNumSerial.serialnumber,newNumSerial.id,openEditRowStoresNumSerial]);
  
  return(
    <>
      {openEditRowStoresNumSerial && 
        <div>
          <SwipeableDrawer
            anchor='right'
            open={true}
            onClose={toggleDrawernewNumSerial(false)}
            onOpen={toggleDrawernewNumSerial(true)}>
            <Container >
              <Box sx={{ bgcolor: '#ffffff',height:'100vh', width: '500px' }}>
                <br/>
                <div id="myDIV">
                  <h1 className="h1NewStyle px-4 mb-2">{openEditNewStoresNumSerial?t('Text_NumSerial_Article_Edit'):t('Text_NumSerial_Article_New')}</h1>
                </div>  
                <hr className="sidebar-divider d-none d-md-block"/>
                <form className="createColorArticle" onSubmit={handleCloseNewNumSerial}>  
                  <div className="form-floating mb-3 px-4 primary">
                    <div className="form-group">
                     <label className="text-primary">{t('Text_SubStore_Selected')} :</label>
                      <TextField
                        id="substore_id"
                        name="substore_id"
                         value={ (newNumSerial.substore_id === undefined || newNumSerial.substore_id ===null || newNumSerial.substore_id ===""
                              || newNumSerial.substore_id ==="0" || newNumSerial.substore_id ===0)?Number(DEFAULTSUBSTORE):newNumSerial.substore_id}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                       inputProps={{ style: {width: 400}, maxLength: 100, }}
                        variant="outlined"
                        onBlur={handleBlurSelectSubStore}
                        onChange={handleChangeSelectSubStore}
                        helperText={errorsNumSerial.substore_id!=null?t(errorsNumSerial.substore_id):""}
                        select
                        SelectProps={{
                            native: true,
                            value: (newNumSerial.substore_id === undefined || newNumSerial.substore_id ===null || newNumSerial.substore_id ===""
                                 || newNumSerial.substore_id ==="0" || newNumSerial.substore_id ===0)?Number(DEFAULTSUBSTORE): newNumSerial.substore_id
                        }}>
                        <option key={0} value=""/>
                        {subStoresToSelect.map((option) => (Number(newNumSerial.store_id)=== Number(option.store_id)) &&
                            <option key={option.id} value={option.id}>
                              {option.name}
                            </option>
                          )
                        }
                      </TextField>
                    </div>
                    {formArticle.applytypesofsize && 
                      <div className="form-group">  
                        <label className="text-primary">{t('Text_Select_TypesOfSizes_Article_Edit')} :</label>
                        <TextField
                          id="typeofsize_id"
                          name="typeofsize_id"
                          value={ (newNumSerial.typeofsize_id === undefined || newNumSerial.typeofsize_id ===null || newNumSerial.typeofsize_id ===""
                                || newNumSerial.typeofsize_id ==="0" || newNumSerial.typeofsize_id ===0)?0:newNumSerial.typeofsize_id}
                          InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                          inputProps={{ style: {width: 400}, maxLength: 100, }}
                          variant="outlined"
                          onBlur={handleBlurSelectTypesOfSize}
                          onChange={handleChangeSelectTypesOfSize}
                          helperText={errorsNumSerial.typeofsize_id!=null?t(errorsNumSerial.typeofsize_id):""}
                          select
                          SelectProps={{
                              native: true,
                              value: (newNumSerial.typeofsize_id === undefined || newNumSerial.typeofsize_id ===null || newNumSerial.typeofsize_id ===""
                              || newNumSerial.typeofsize_id ==="0" || newNumSerial.typeofsize_id ===0)?0: newNumSerial.typeofsize_id
                          }}>
                          <option key={0} value=""/>
                          {typesOfSizeToSelect.map((option) => (formArticle.articlesizes.find((item) => {return(Number(item.typeofsize_id)=== Number(option.id))})) &&
                              <option key={option.id} value={option.id}>
                                {(i18n.language==="es"?option.namees:option.nameen)}
                              </option>
                            )
                          }
                        </TextField>
                      </div>
                    }
                    {formArticle.applycolor && 
                      <div className="form-group">  
                        <label className="text-primary">{t('Text_Select_Color_Article_Edit')} :</label>
                        <TextField
                          id="color_id"
                          name="color_id"
                          value={ (newNumSerial.color_id === undefined || newNumSerial.color_id ===null || newNumSerial.color_id ===""
                                || newNumSerial.color_id ==="0" || newNumSerial.color_id ===0)?0:newNumSerial.color_id}
                          InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                          inputProps={{ style: {color:newNumSerial.color_codehex, width: 400}, maxLength: 100, }}
                          variant="outlined"
                          onBlur={handleBlurSelectColor}
                          onChange={handleChangeSelectColor}
                          helperText={errorsNumSerial.color_id!=null?t(errorsNumSerial.color_id):""}
                          select
                          SelectProps={{
                              native: true,
                              value: (newNumSerial.color_id === undefined || newNumSerial.color_id ===null || newNumSerial.color_id ===""
                              || newNumSerial.color_id ==="0" || newNumSerial.color_id ===0)?0: newNumSerial.color_id
                          }}>
                          <option key={0} value=""/>
                          { colorToSelect.map((option) => (formArticle.articlecolors.find((item) => {return(Number(item.color_id)=== Number(option.id))})) &&
                              <option key={option.id} value={option.id}>
                                {(i18n.language==="es"?option.namees:option.nameen)}
                              </option>
                            )
                          }
                        </TextField>
                      </div>
                      }
                    <div className="form-group">  
                      <label className="text-primary">{t('Text_NumSerial_Article')} :</label>
                      <TextField
                        id="serialnumber" 
                        name="serialnumber"
                        value={newNumSerial.serialnumber}
                        InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                        inputProps={{ style: {width: 450}, maxLength: 50  }}
                        label={errorsNumSerial.serialnumber!=null?t(errorsNumSerial.serialnumber):t('PlaceHolder_NumSerial')}
                        placeholder={t('PlaceHolder_NumSerial')}
                        variant="standard"
                        onBlur={handleBlurNewNumSerial}
                        onChange={handleChangeNewNumSerial}/>
                    </div> 
                    <hr className="sidebar-divider d-none d-md-block"/>
                    <div className="btn-group d-grid d-md-flex justify-content-md-end" role="group">
                      <button className="btn btn-primary btn-lg " type="button" onClick={handleSubmitNewNumSerial}>{openEditNewStoresNumSerial?t('Button_Update'):t('Button_Create')}</button><> </>
                      <button className="btn btn-outline-secondary btn-lg" type="button" onClick={handleCloseNewNumSerial}>{t('Button_Cancel')}</button>
                    </div>
                  </div>
                </form>
              </Box>
            </Container>
          </SwipeableDrawer>
        </div>
      }  
    </>
  )
}

ArticleCreateOrEditNumSerial.propTypes = { 
  openEditRowStoresNumSerial: PropTypes.bool.isRequired,
  setOpenEditRowStoresNumSerial: PropTypes.func.isRequired,
  openEditNewStoresNumSerial: PropTypes.bool.isRequired,
  setOpenEditNewStoresNumSerial: PropTypes.func.isRequired,
  formArticle: PropTypes.object.isRequired,
  setFormArticle: PropTypes.func.isRequired, 
  setEditRowStoreNumSerial: PropTypes.func.isRequired
};

export default ArticleCreateOrEditNumSerial;